import './menu-icon.scss';

const MenuIcon = ({ onClick = () => {} }) => {
  return (
    <div onClick={onClick} className="menu-icon">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
};

export default MenuIcon;
